import { sortBy, uniqBy } from 'lodash-es';

import type { ReportVersionDto } from '@src/api';
import type { ReportVersionDtoDefId } from '@stores/dictionaryStores/reportVersion/reportVersionsStore';

type ReportVersionWithChildrenDtoDefId = ReportVersionDto & {
  children?: ReportVersionWithChildrenDtoDefId[];
  key: string;
  title: string;
};

// Группировка по report_group (1 уровень иерархии), по report_version (2 уровень иерархии)
export const toTreeView = (reportVersions: ReportVersionDtoDefId[]): ReportVersionWithChildrenDtoDefId[] => {
  const output = sortBy(
    reportVersions.filter((report) => report.reportGroupCode && report.reportTypeCode),
    ['reportGroupCode', 'reportTypeOrderNum', 'reportTypeCode'],
  );

  return uniqBy(output, 'reportGroupCode').map((item) => ({
    reportGroupCode: item.reportGroupCode,
    key: item.reportGroupCode ?? '',
    title: `${item.reportGroupCode ?? ''}${item.reportGroupCode && item.reportGroupName ? ' - ' : ''}${
      item.reportGroupName ?? ''
    }`,
    children:
      uniqBy(
        output.filter((el) => el.reportGroupCode === item.reportGroupCode),
        'reportTypeCode',
      )
        .map((ver) => ({
          reportGroupCode: ver.reportGroupCode,
          reportTypeCode: ver.reportTypeCode,
          key: `${ver.reportGroupCode} - ${ver.reportTypeCode}`,
          title: `${ver.reportTypeCode ?? ''}${ver.reportTypeCode && ver.reportTypeName ? ' - ' : ''}${
            ver.reportTypeName ?? ''
          }`,
          count: reportVersions.filter(
            (report) => report.reportGroupCode === ver.reportGroupCode && report.reportTypeCode === ver.reportTypeCode,
          ).length,
        }))
        .sort((a) => {
          if (a.reportTypeCode === 'KND') return -1;
          return 0;
        }) ?? [],
  }));
};
